import type { RouteObject } from "react-router";

import type { RouteHandle } from "shell/platform/types/types";

export const withProductArea = (
  routes: RouteObject[],
  area: string,
): RouteObject[] =>
  routes.map(route => ({
    ...route,
    // An area already on the route wins over the module id.
    handle: { productArea: area, ...(route.handle as RouteHandle) },
  }));
